var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5C12C",
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.556 22.428a1.1 1.1 0 0 1-.567.159c-.181 0-.386-.046-.567-.159l-9.031-5.514v7.33a2.84 2.84 0 0 0 2.836 2.837h13.548a2.84 2.84 0 0 0 2.837-2.837v-7.33l-9.054 5.514z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.773 12.922H13.227a2.82 2.82 0 0 0-2.747 2.224l9.53 5.81 9.509-5.81a2.82 2.82 0 0 0-2.746-2.224"
  })));
};
export default SvgEmail;